import { z } from 'zod';
import { IdSchema, NameSchema } from '../resource-base/baseSchemas';
import { msObject } from '../resource-base/msObject';
import { Enum } from '../../../../react-commons/types/enum';

export const PersistableOutlineBaseSchema = msObject({
    id: IdSchema,
});

export const NamedOutlineBaseSchema = msObject({
    name: NameSchema,
});

export const NamedPersistableOutlineSchema = PersistableOutlineBaseSchema.merge(NamedOutlineBaseSchema);

export const ArtifactOutlineBaseSchema = PersistableOutlineBaseSchema.extend({
    objectId: IdSchema,
});

export const NamedArtifactOutlineSchema = ArtifactOutlineBaseSchema.merge(NamedPersistableOutlineSchema);

export const getTypedOutlineSchema = <TE extends string>(typeEnum: Enum<TE>) =>
    msObject({
        type: z.enum(typeEnum),
    });

export const getTypedNamedPersistableOutlineBaseSchema = <TE extends string>(typeEnum: Enum<TE>) =>
    NamedPersistableOutlineSchema.merge(getTypedOutlineSchema(typeEnum));

export const getTypedNamedArtifactOutlineSchema = <TE extends string>(typeEnum: Enum<TE>) => NamedArtifactOutlineSchema.merge(getTypedOutlineSchema(typeEnum));

const getCategorizedOutlineSchema = <CE extends string>(categoryEnum: Enum<CE>) =>
    msObject({
        category: z.enum(categoryEnum),
    });

export const getCategorizedNamedArtifactOutlineSchema = <CE extends string>(categoryEnum: Enum<CE>) =>
    NamedArtifactOutlineSchema.merge(getCategorizedOutlineSchema(categoryEnum));

export const getVariantedArtifactOutlineBaseSchema = <VS extends typeof NamedArtifactOutlineSchema>(variantSchema: VS) =>
    NamedArtifactOutlineSchema.extend({
        variants: variantSchema.array(),
    });

export const ArtifactVariantOutlineSchema = NamedArtifactOutlineSchema.extend({
    isActive: z.boolean(),
});

export const InstancedBySchema = NamedPersistableOutlineSchema.extend({
    instancedBy: z.enum(['COMPOSITION', 'PROJECT_LINE_VERSION', 'DEPLOYMENT_UNIT']),
});

export type NamedPersistableOutline = z.infer<typeof NamedPersistableOutlineSchema>;
export type NamedArtifactOutline = z.infer<typeof NamedArtifactOutlineSchema>;
